import { gql } from 'graphql-request'

export const CREATE_USER_CONSENT = gql`
  mutation CreateUserConsent {
    createUserConsent
  }
`
